<template>
  <div>
    <slot>
      <CustomBtnToggle
          :value="tripType"
          data-test="tripTypeToggle"
          :items="tripTypeItems"
          @change="setTripType"
      />
    </slot>
  </div>
</template>
<script lang="ts">
export default {
  name: 'STripTypeSelection',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import TripTypeEnum from '@slg/web-customer-shared/src/enum/TripTypeEnum';
import CustomBtnToggle from '@slg/web-customer-shared/src/components/common/CustomBtnToggle.vue';
import { useI18n } from '../../../composables';

defineProps({
  tripType: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['setTripType']);
const { t } = useI18n();

const tripTypes = [TripTypeEnum.ONE_WAY, TripTypeEnum.ROUND_TRIP];

const tripTypeItems = computed(() => {
  const availableTripTypes = tripTypes.map((trip) => (
    {
      text: t(`bookingForm.${trip}`),
      value: trip,
    }
  ));
  return availableTripTypes;
});

function setTripType(newType) {
  emit('setTripType', newType);
}
</script>

<style scoped lang="scss">
</style>
